import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import {
  FiPlus,
  FiEdit2,
  FiTrash2,
  FiCpu,
  FiX,
  FiSave,
  FiCamera,
  FiWifi,
  FiWifiOff,
  FiMapPin,
  FiHome,
  FiSearch,
  FiFilter,
  FiRefreshCw,
  FiLink,
  FiUnlink,
  FiBarChart2,
} from "react-icons/fi";
import { useAuth } from "../context/AuthContext";
import { getMyFarms } from "../api/farmApi";
import { toast } from "react-toastify";
// import QRScanner from "../components/QRScanner";
import { createMCU, deleteMCU, getMCUsByClientId, updateMCU } from "../api/mcuApi";
import LinkProfileSelector from "../components/LinkProfileSelector";


const MCUManager = () => {
  const { clientData } = useAuth();

  const [mcus, setMcus] = useState([]);

  const [farms, setFarms] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [editingMCU, setEditingMCU] = useState(null);
  const [showScanner, setShowScanner] = useState(false);
  const [scannedMAC, setScannedMac] = useState("");
  const [filterStatus, setFilterStatus] = useState("all");
  const [filterFarm, setFilterFarm] = useState("all");
  const [searchTerm, setSearchTerm] = useState("");

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const loadFarms = async () => {
      try {
        if (!clientData?.client_id) return;
        const result = await getMyFarms(clientData.client_id);
        const formatted = result.map((farm) => ({
          ...farm,
          createdAt: new Date(farm.createdAt).toLocaleDateString(),
        }));
        setFarms(formatted);
      } catch (err) {
        toast.info(err.message);
      }
    };
    const loadMCUs = async () => {
      try {
        if (!clientData?.client_id) return;
        const result = await getMCUsByClientId(clientData.client_id);
        const formatted = result.map((mcu) => ({
          ...mcu,
          createdAt: new Date(mcu.createdAt).toLocaleDateString(),
          updatedAt: new Date(mcu.updatedAt).toLocaleDateString(),
          farmName: mcu?.farm?.name || "",
         farm_id: parseInt(mcu.farm_id),
         controllers: mcu?.controllers.length,
         sensors:mcu?.sensors.length,
        }));
        setMcus(formatted);
      } catch (err) {
        toast.info(err.message);
      }
    };

    loadFarms();
    loadMCUs();
  }, [clientData]);

  const openModal = (mcu = null) => {
    setEditingMCU(mcu);
    setShowModal(true);
    if (mcu) {
      reset({
        name: mcu.name,
        farm_id: mcu.farm_id,
        mac: mcu.mac,
      });
    } else {
      reset({
        name: "",
        farm_id: "",
        mac: scannedMAC || "",
      });
    }
  };

  const closeModal = () => {
    setShowModal(false);
    setEditingMCU(null);
    setScannedMac("");
    reset();
  };

  const openScanner = () => {
    setShowScanner(true);
  };

  // const handleMCUScan = (data) => {
  //   const mac = data.trim();
  //   console.log(mac);
  //   setShowScanner(false);
  //   setShowModal(true);
  //   reset({ name: "", mac: mac, farm_id: "" });
  //   toast.success(`Scanned: ${mac}`);
  // };

  // const handleMCUError = (error, message) => {
  //   console.error("MCU Scanner Error:", error);
  //   toast.error(`Scanner Error: ${message}`);
  // };

  const onSubmit = async (data) => {
    const selectedFarm = farms.find(
      (farm) => farm.farm_id === parseInt(data.farm_id)
    );

    if (editingMCU) {
      const result = await updateMCU(editingMCU.mcu_id, data);
      toast.success(result.name + " MCU updated successfully");
      setMcus(
        mcus.map((mcu) =>
          mcu.mcu_id === editingMCU.mcu_id
            ? {
                ...mcu,
                ...data,
                farmName: selectedFarm?.name || "",
                farm_id: parseInt(data.famr_id),
              }
            : mcu
        )
      );
    } else {
      try {
        const payload = { ...data, status: "active" };
        const newMCU = await createMCU(payload);
        setMcus([...mcus, newMCU]);
      } catch (error) {
        toast.error("Creation failed : " + error);
      }
    }
    closeModal();
  };

  const deleteMyMCU = async (mcu_id) => {
    if (
      window.confirm(
        "Are you sure you want to delete this MCU? This action cannot be undone."
      )
    ) {
      try {
        const result = await deleteMCU(mcu_id);
        toast.success(result.message);
        setMcus(mcus.filter((mcu) => mcu.mcu_id !== mcu_id));
      } catch (error) {
        toast.error("Delete failed : " + error);
      }
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case "online":
        return "text-green-600 bg-green-100";
      case "offline":
        return "text-red-600 bg-red-100";
      case "maintenance":
        return "text-yellow-600 bg-yellow-100";
      default:
        return "text-gray-600 bg-gray-100";
    }
  };


  const getBatteryColor = (level) => {
    if (level > 50) return "text-green-600";
    if (level > 20) return "text-yellow-600";
    return "text-red-600";
  };

  const filteredMCUs = mcus.filter((mcu) => {
    console.log(mcus)
    const matchesSearch =
      mcu.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      mcu.mac.includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === "all" || mcu.status === filterStatus;
    const matchesFarm =
      filterFarm === "all" || mcu.farm_id === parseInt(filterFarm);
      console.log(filterFarm);

    return matchesSearch && matchesStatus && matchesFarm;
  });

  const formatLastSeen = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);

    if (diffMins < 1) return "Just now";
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffMins < 1440) return `${Math.floor(diffMins / 60)}h ago`;
    return `${Math.floor(diffMins / 1440)}d ago`;
  };
  const scannerRef = useRef();

  // Optional: If you want to programmatically stop the camera before closing
  // const forceCloseScanner = () => {
  //   if (scannerRef.current) {
  //     scannerRef.current.stopCamera(); // Force stop camera
  //   }
  //   setShowScanner(false); // Then close
  // };
  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">MCU Manager</h1>
          <p className="text-gray-600 mt-1">
            Manage your IoT controllers and monitoring devices
          </p>
        </div>
        <div className="flex items-center space-x-3">
          <button
            onClick={openScanner}
            className="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
          >
            <FiCamera className="w-4 h-4 mr-2" />
            Scan MCU
          </button>
          <button
            onClick={() => openModal()}
            className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            <FiPlus className="w-4 h-4 mr-2" />
            Add MCU
          </button>
        </div>
      </div>

      {/* Filters and Search */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
        <div className="flex flex-col sm:flex-row gap-4">
          {/* Search */}
          <div className="flex-1">
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <FiSearch className="h-5 w-5 text-gray-400" />
              </div>
              <input
                type="text"
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Search MCUs by name, ID, or MAC address..."
              />
            </div>
          </div>

          {/* Status Filter */}
          <div className="sm:w-48">
            <select
              value={filterStatus}
              onChange={(e) => setFilterStatus(e.target.value)}
              className="block w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="all">All Status</option>
              <option value="active">Active</option>
              <option value="online">Online</option>
              <option value="offline">Offline</option>
              <option value="maintenance">Maintenance</option>
            </select>
          </div>

          {/* Farm Filter */}
          <div className="sm:w-48">
            <select
              value={filterFarm}
              onChange={(e) => setFilterFarm(e.target.value)}
              className="block w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option key={0} value="all">
                All Farms
              </option>
              {farms.map((farm) => (
                <option key={farm.farm_id} value={farm.farm_id}>
                  {farm.name}
                </option>
              ))}
            </select>
          </div>

          <button
            onClick={() => {
              setSearchTerm("");
              setFilterStatus("all");
              setFilterFarm("all");
            }}
            className="px-4 py-2 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors flex items-center"
          >
            <FiRefreshCw className="w-4 h-4 mr-2" />
            Reset
          </button>
        </div>
      </div>

      {/* Stats Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Total MCUs</p>
              <p className="text-2xl font-bold text-gray-900">{mcus.length}</p>
            </div>
            <div className="p-3 bg-blue-100 rounded-lg">
              <FiCpu className="w-6 h-6 text-blue-600" />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Online</p>
              <p className="text-2xl font-bold text-green-600">
                {mcus.filter((m) => m.status === "online").length}
              </p>
            </div>
            <div className="p-3 bg-green-100 rounded-lg">
              <FiWifi className="w-6 h-6 text-green-600" />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Offline</p>
              <p className="text-2xl font-bold text-red-600">
                {mcus.filter((m) => m.status === "offline").length}
              </p>
            </div>
            <div className="p-3 bg-red-100 rounded-lg">
              <FiWifiOff className="w-6 h-6 text-red-600" />
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm font-medium text-gray-600">Low Battery</p>
              <p className="text-2xl font-bold text-yellow-600">
                {mcus.filter((m) => m.batteryLevel < 30).length}
              </p>
            </div>
            <div className="p-3 bg-yellow-100 rounded-lg">
              <FiBarChart2 className="w-6 h-6 text-yellow-600" />
            </div>
          </div>
        </div>
      </div>

      {/* MCU Grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
        {filteredMCUs.map((mcu) => {
       
          return (
            <div
              key={mcu.mcu_id}
              className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden hover:shadow-md transition-shadow"
            >
              {/* MCU Header */}
              <div className="p-6 border-b border-gray-100">
                <div className="flex items-center justify-between mb-4">
                  <div className="flex items-center space-x-3">
                    <div className="p-2 bg-indigo-100 rounded-lg">
                      <FiCpu className="w-5 h-5 text-indigo-600" />
                    </div>
                    <div>
                      <h3 className="font-semibold text-gray-900">
                        {mcu.name}
                      </h3>
                      <p className="text-sm text-gray-600">{mcu.mcu_id}</p>
                    </div>
                  </div>

                  <div className="flex items-center space-x-2">
                    <div
                      className={`px-2 py-1 rounded-full text-xs font-medium ${getStatusColor(
                        mcu.status
                      )}`}
                    >
                      {mcu.status}
                    </div>
                    <button
                      onClick={() => openModal(mcu)}
                      className="p-2 text-gray-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-colors"
                    >
                      <FiEdit2 className="w-4 h-4" />
                    </button>
                    <button
                      onClick={() => deleteMyMCU(mcu.mcu_id)}
                      className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-colors"
                    >
                      <FiTrash2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>

                {/* Farm Link */}
                <div className="flex items-center space-x-2 mb-3">
                  <FiLink className="w-4 h-4 text-gray-400" />
                  <span className="text-sm text-gray-600">
                    Linked to{" "}
                    <span className="font-medium text-gray-900">
                      {mcu.farmName}
                    </span>
                  </span>
                </div>
             <LinkProfileSelector mcu_id={mcu.mcu_id} mac={mcu.mac} profile_id={mcu.profile_links[0]?.profile_id}/>
           
              </div>

              {/* MCU Details */}
              <div className="p-6 space-y-4">
                {/* MAC Address */}
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-700">
                    MAC Address
                  </span>
                  <span className="text-sm text-gray-600 font-mono">
                    {mcu.mac}
                  </span>
                </div>


                {/* Battery Level */}
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-700">
                    Battery
                  </span>
                  <div className="flex items-center space-x-2">
                    <div className="w-12 h-2 bg-gray-200 rounded-full">
                      <div
                        className={`h-2 rounded-full ${getBatteryColor(
                          mcu?.readings?.batteryLevel
                        )} bg-current`}
                        style={{ width: `${mcu?.readings?.batteryLevel}%` }}
                      ></div>
                    </div>
                    <span
                      className={`text-sm font-medium ${getBatteryColor(
                        mcu?.readings?.batteryLevel
                      )}`}
                    >
                      {mcu?.readings?.batteryLevel}%
                    </span>
                  </div>
                </div>

                {/* Last Seen */}
                <div className="flex items-center justify-between">
                  <span className="text-sm font-medium text-gray-700">
                    Last Seen
                  </span>
                  <span className="text-sm text-gray-600">
                    {formatLastSeen(mcu?.updatedAt)}
                  </span>
                </div>

                {/* Created Date */}
                <div className="flex items-center justify-between pt-2 border-t border-gray-100">
                  <span className="text-xs font-medium text-gray-500">
                    Added
                  </span>
                  <span className="text-xs text-gray-500">{mcu.createdAt}</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* Empty State */}
      {filteredMCUs.length === 0 && (
        <div className="text-center py-12">
          <FiCpu className="w-16 h-16 text-gray-300 mx-auto mb-4" />
          <h3 className="text-lg font-medium text-gray-900 mb-2">
            No MCUs found
          </h3>
          <p className="text-gray-600 mb-6">
            {searchTerm || filterStatus !== "all" || filterFarm !== "all"
              ? "No MCUs match your current filters."
              : "Get started by adding your first MCU device."}
          </p>
          {!searchTerm && filterStatus === "all" && filterFarm === "all" && (
            <div className="flex items-center justify-center space-x-3">
              <button
                onClick={openScanner}
                className="inline-flex items-center px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
              >
                <FiCamera className="w-4 h-4 mr-2" />
                Scan Barcode
              </button>
              <button
                onClick={() => openModal()}
                className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
              >
                <FiPlus className="w-4 h-4 mr-2" />
                Add Manually
              </button>
            </div>
          )}
        </div>
      )}

      {/* Barcode Scanner Modal */}
      {/* {showScanner && (
        <QRScanner
          ref={scannerRef}
          isOpen={showScanner}
          onClose={forceCloseScanner}
          onScan={handleMCUScan}
          onError={handleMCUError}
          title="Scan MCU Barcode"
          instructions="Position the MCU barcode within the frame to scan"
        />
      )} */}

      {/* Add/Edit MCU Modal */}
      {showModal && (
        <div className="fixed inset-0 z-50 overflow-y-auto">
          <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
            <div
              className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75"
              onClick={closeModal}
            ></div>

            <div className="inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl">
              <div className="flex items-center justify-between mb-6">
                <h3 className="text-lg font-semibold text-gray-900">
                  {editingMCU ? "Edit MCU" : "Add New MCU"}
                </h3>
                <button
                  onClick={closeModal}
                  className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100 rounded-lg"
                >
                  <FiX className="w-5 h-5" />
                </button>
              </div>

              <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
                {/* MCU Name */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    MCU Name
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <FiCpu className="h-5 w-5 text-gray-400" />
                    </div>
                    <input
                      type="text"
                      {...register("name", {
                        required: "MCU name is required",
                      })}
                      className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                      placeholder="Enter MCU name"
                    />
                  </div>
                  {errors.name && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.name.message}
                    </p>
                  )}
                </div>

                {/* MAC Address */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    MAC Address
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      {...register("mac", {
                        required: "MAC address is required",
                        pattern: {
                          value: /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/,
                          message: "Invalid MAC address format",
                        },
                      })}
                      className="block w-full px-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors font-mono"
                      placeholder="AA:BB:CC:DD:EE:FF"
                    />
                    {!editingMCU && (
                      <button
                        type="button"
                        onClick={openScanner}
                        className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-blue-600"
                      >
                        <FiCamera className="h-5 w-5" />
                      </button>
                    )}
                  </div>
                  {errors.mac && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.mac.message}
                    </p>
                  )}
                </div>

                {/* Farm Selection */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Assign to Farm
                  </label>
                  <div className="relative">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                      <FiHome className="h-5 w-5 text-gray-400" />
                    </div>
                    <select
                      {...register("farm_id", {
                        required: "Please select a farm",
                      })}
                      className="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors"
                    >
                      <option value="">Select a farm</option>
                      {farms.map((farm) => (
                        <option key={farm.farm_id} value={farm.farm_id}>
                          {farm.name} - {farm.location}
                        </option>
                      ))}
                    </select>
                  </div>
                  {errors.farm_id && (
                    <p className="text-red-500 text-sm mt-1">
                      {errors.farm_id.message}
                    </p>
                  )}
                </div>

                {/* Buttons */}
                <div className="flex items-center justify-end space-x-3 pt-4">
                  <button
                    type="button"
                    onClick={closeModal}
                    className="px-4 py-2 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
                  >
                    <FiSave className="w-4 h-4 mr-2" />
                    {editingMCU ? "Update MCU" : "Add MCU"}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MCUManager;
